// API-URL: bruk REACT_APP_BACKEND_URL, eller Vercel når på smakglod.com (custom hosting)
const getApiBase = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && /smakglod\.com$/i.test(window.location.hostname)) {
    return 'https://smak-blond.vercel.app';
  }
  return '';
};
export const API = getApiBase() ? `${getApiBase()}/api` : '/api';
